var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.877,
    height: 33.815,
    viewBox: "0 0 33.877 33.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2384",
    "data-name": "Rectangle 2384",
    width: 33.877,
    height: 33.815,
    fill: "#101b2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10417",
    "data-name": "Group 10417",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10416",
    "data-name": "Group 10416",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29378",
    "data-name": "Path 29378",
    d: "M25.366,22.458a3.373,3.373,0,0,0-4.789,0l-1.631,1.631a29.5,29.5,0,0,1-5.081-4.079A30.318,30.318,0,0,1,9.786,14.93L11.417,13.3a3.373,3.373,0,0,0,0-4.789L8.231,5.329a3.3,3.3,0,0,0-2.377-.992,3.4,3.4,0,0,0-2.4.992L1.922,6.849A7.179,7.179,0,0,0,.074,12.763c.358,4.226,3.134,9.307,7.4,13.591S16.886,33.4,21.112,33.8a8.263,8.263,0,0,0,.945,0,6.843,6.843,0,0,0,4.97-1.848l1.52-1.532a3.4,3.4,0,0,0,.992-2.4,3.3,3.3,0,0,0-.992-2.377Zm1.591,6.373-1.532,1.52A5.144,5.144,0,0,1,21.3,31.477c-3.663-.311-8.327-2.9-12.178-6.76S2.679,16.238,2.327,12.576A5.1,5.1,0,0,1,3.454,8.45L5.045,6.918a1.135,1.135,0,0,1,1.6,0L9.833,10.14a1.134,1.134,0,0,1,0,1.591L7.579,13.985A1.119,1.119,0,0,0,7.4,15.346a30.868,30.868,0,0,0,4.876,6.284,30.9,30.9,0,0,0,6.292,4.882,1.126,1.126,0,0,0,1.361-.182l2.253-2.253a1.133,1.133,0,0,1,1.589,0l3.188,3.186a1.157,1.157,0,0,1,.327.805,1.107,1.107,0,0,1-.327.762M28.916,4.947A16.793,16.793,0,0,0,16.974,0a1.127,1.127,0,1,0,0,2.253A14.657,14.657,0,0,1,31.622,17.024a1.127,1.127,0,1,0,2.253,0A16.8,16.8,0,0,0,28.916,4.947",
    transform: "translate(0 0)",
    fill: "#101b2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29379",
    "data-name": "Path 29379",
    d: "M16.953,9.011a6.789,6.789,0,0,1,2,4.858,1.127,1.127,0,1,0,2.253,0,9.018,9.018,0,0,0-9.014-9.131,1.127,1.127,0,1,0,0,2.253,6.785,6.785,0,0,1,4.765,2.019",
    transform: "translate(5.556 2.38)",
    fill: "#101b2d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call_icon.4d7f857c3975eb074afb216a2c030630.svg";
export { ForwardRef as ReactComponent };